import axios from "../../api/axios.js";
import React, { useState } from "react";
import md5 from "md5";
import { getFetchOptions } from "../../js/utility.js";

const Login = () => {
  const [email, setEmail] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(
    window.location.pathname.split("/").pop() == "admin"
      ? "admin"
      : "insegnante"
  );
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [modalResetPassword, setModalResetPassword] = useState(false);

  const baseUrlLogin = axios.defaults.baseURL + "/auth/user/login";

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = () => {
    if (email !== "" && password !== "") {
      const data = {};
      data["email"] = email;
      data["password"] = password;
      data["ruolo"] = role;

      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        data,
        "POST"
      );
      fetch(baseUrlLogin, fetchOptions)
        .then((response) => response.json())
        .then((result) => {
          const userToken = result.return.token;
          const userRole = result.return.utente.ruolo;
          const userID = result.return.utente.id;
          const userName = result.return.utente.nominativo;
          const userImg = result.return.utente.tokenimg;
          const userSchoolId = result.return.utente.idscuola;

          const tokenParts = userToken.split(".");
          if (tokenParts.length === 3) {
            try {
              const payload = JSON.parse(atob(tokenParts[1]));
              const tokenExp = payload.exp;
              localStorage.setItem("tokenExp", Number(tokenExp) * 1000);
            } catch (e) {
              console.error("Errore nella decodifica del token JWT:", e);
            }
          }

          localStorage.setItem("token", userToken);
          localStorage.setItem("role", userRole);
          localStorage.setItem("userId", userID);
          localStorage.setItem("userName", userName);
          localStorage.setItem("userImg", userImg);
          localStorage.setItem("userSchoolId", userSchoolId);

          window.location.href = "/";
        })
        .catch((error) => {
          alert("Login non riuscito, controllare i dati inseriti", "Errore");
        });

      //   axios
      //     .post(baseUrlLogin, {
      //       email,
      //       password: password,
      //       ruolo: role,
      //     })
      //     .then((response) => {
      //       if (response.status === 200) {
      //         localStorage.setItem("token", response.data.token);
      //         localStorage.setItem("role", response.data.utente.ruolo);
      //         localStorage.setItem("userId", md5(response.data.utente.id));
      //         window.location.href = "/dashboard";
      //       } else {
      //         alert("Login non riuscito", "Errore");
      //       }
      //     });
    } else {
      alert("Compilare tutti i campi", "Errore");
    }
  };

  const handleSendNewPassword = async () => {
    if (resetEmail == "") {
      alert("Inserire un'email valida", "Errore");
      return;
    }

    const fetchCheckOptions = getFetchOptions(
      "application/json",
      { email: resetEmail },
      "POST"
    );

    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/sendResetPasswordEmail`,
      fetchCheckOptions
    )
      .then((response) => {
        response.json().then((result) => {
          if (!result.error) {
            alert("Email inviata con successo");
            setModalResetPassword(false);
          } else {
            alert("Errore durante l'invio dell'email: " + result.message);
          }
        });
      })
      .catch((error) => {
        alert("Errore durante l'invio dell'email: " + error.message);
      });
  };

  return (
    <div className="row authentication mx-0">
      {/* Login form */}
      <div className="col-xxl-6 col-xl-6 col-lg-12">
        <div className="row justify-content-center align-items-center h-100">
          <div className="col-xxl-8 col-xl-9 col-lg-6 col-md-6 col-sm-8 col-12">
            <div className="card custom-card shadow-none my-4">
              <div className="card-body p-4">
                <form id="formLogin">
                  {/* CSRF token can be added here if necessary */}
                  <div className="mb-3 d-flex justify-content-center">
                    <i className="bi bi-person-fill-lock icon-title"></i>
                  </div>
                  <div className="row gy-3">
                    <div className="col-xl-12">
                      <div className="form-group">
                        <label
                          htmlFor="signin-username"
                          className="form-label text-default"
                        >
                          Email
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          id="email"
                          name="email"
                          placeholder="user name"
                          value={email}
                          onChange={handleEmailChange}
                        />
                        <span className="error" id="emailError">
                          {emailError}
                        </span>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group">
                        <label
                          htmlFor="signin-password"
                          className="form-label text-default"
                        >
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-lg"
                            id="password"
                            name="password"
                            placeholder="password"
                            value={password}
                            onChange={handlePasswordChange}
                          />
                          <a
                            href="#"
                            id="showPassword"
                            className="show-password-button text-muted"
                            onClick={togglePasswordVisibility}
                          >
                            <i
                              className={
                                showPassword
                                  ? "ri-eye-line align-middle"
                                  : "ri-eye-off-line align-middle"
                              }
                            ></i>
                          </a>
                        </div>
                        <span className="error" id="passwordError">
                          {passwordError}
                        </span>
                      </div>
                      <span className="form-text text-muted">
                        <a href="#" onClick={() => setModalResetPassword(true)}>
                          Password dimenticata?
                        </a>
                      </span>
                    </div>
                  </div>

                  <div className="mt-3 d-flex justify-content-end align-items-center">
                    <button
                      type="button"
                      className="btn btn-lg btn-primary"
                      id="btnLogin"
                      onClick={handleLogin}
                    >
                      Accedi
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Reset Password Modal */}
        {modalResetPassword && (
          <>
            <div
              className="modal fade show d-flex justify-content-center align-items-center"
              id="resetPasswordModal"
              tabIndex="-1"
              role="dialog"
              style={{
                display: "block",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1050,
              }}
              aria-modal="true"
            >
              <div
                className="modal-dialog"
                role="document"
                style={{ maxWidth: "600px", width: "90%" }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Invia email di Reset Password
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setModalResetPassword(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label htmlFor="newPassword" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          onChange={(e) => setResetEmail(e.target.value)}
                        />
                      </div>
                      <div className="d-flex justify-content-end align-items-center">
                        <button
                          type="button"
                          className="btn btn-primary mt-3"
                          onClick={handleSendNewPassword}
                        >
                          Invia
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal-backdrop fade show"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            ></div>
          </>
        )}
      </div>

      {/* Left Side */}
      <div className="col-xxl-6 col-xl-6 col-lg-7 d-xl-block d-none px-0">
        <div className="authentication-cover bg-primary">
          <div className="d-flex justify-content-center">
            <img src="/assets/images/brand-logos/toggle-dark.png" alt="Logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
